/* global Office, Word */

var API_URL =
  typeof __API_URL__ !== "undefined" && __API_URL__ ? __API_URL__ : "https://127.0.0.1:8000";
var EDIT_API_URL = API_URL + "/edit-paragraph";
var PLAN_API_URL = API_URL + "/make-doc-edit-plan";
var PLAN_STATUS_URL = API_URL + "/doc-edit-plan";
var API_KEY = typeof __API_KEY__ !== "undefined" ? __API_KEY__ : "";
const CC_TAG = "AI_EDIT";

// Debug: log config on load
console.log("Add-in config:", { API_URL: API_URL, API_KEY: API_KEY ? "(set)" : "(empty)" });

// ========== Utility Functions ==========

function fastHash(str) {
  var h = 2166136261;
  for (var i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16);
}

// ========== UI Helper Functions ==========

function setButtonLoading(buttonId, isLoading) {
  var btn = document.getElementById(buttonId);
  if (!btn) return;
  
  var btnText = btn.querySelector(".btn-text");
  var btnSpinner = btn.querySelector(".btn-spinner");
  
  if (isLoading) {
    btn.disabled = true;
    if (btnSpinner) btnSpinner.style.display = "inline-flex";
  } else {
    btn.disabled = false;
    if (btnSpinner) btnSpinner.style.display = "none";
  }
}

function setStatus(elementId, message, type) {
  var statusEl = document.getElementById(elementId);
  if (!statusEl) return;
  
  statusEl.textContent = message || "";
  statusEl.className = "status-message ms-font-s";
  
  if (type === "error") {
    statusEl.classList.add("error");
  } else if (type === "success") {
    statusEl.classList.add("success");
  }
}

function showSection(sectionId, show) {
  var section = document.getElementById(sectionId);
  if (section) {
    section.style.display = show ? "block" : "none";
  }
}

function updatePlanCount() {
  var countEl = document.getElementById("plan-count");
  var listEl = document.getElementById("doc-plan-list");
  if (!countEl || !listEl) return;
  
  var items = listEl.querySelectorAll(".plan-item");
  countEl.textContent = "(" + items.length + ")";
}

function updateApplyButtonState() {
  var applyBtn = document.getElementById("run-ai-edits");
  var listEl = document.getElementById("doc-plan-list");
  
  if (!applyBtn || !listEl) return;
  
  var selectedCount = getSelectedCount();
  var btnText = applyBtn.querySelector(".btn-text");
  
  if (selectedCount > 0) {
    applyBtn.disabled = false;
    if (btnText) {
      btnText.textContent = "Apply " + selectedCount + " Change" + (selectedCount === 1 ? "" : "s");
    }
  } else {
    applyBtn.disabled = true;
    if (btnText) {
      btnText.textContent = "Apply Selected Changes";
    }
  }
}

function getSelectedCount() {
  var listEl = document.getElementById("doc-plan-list");
  if (!listEl) return 0;
  
  var checkboxes = listEl.querySelectorAll('input[type="checkbox"]:checked');
  return checkboxes.length;
}

// ========== Confirmation Dialog ==========

var pendingConfirmCallback = null;

function showConfirmDialog(message, onConfirm) {
  var dialog = document.getElementById("confirm-dialog");
  var messageEl = document.getElementById("confirm-message");
  
  if (!dialog || !messageEl) return;
  
  messageEl.textContent = message;
  pendingConfirmCallback = onConfirm;
  dialog.style.display = "flex";
}

function hideConfirmDialog() {
  var dialog = document.getElementById("confirm-dialog");
  if (dialog) {
    dialog.style.display = "none";
  }
  pendingConfirmCallback = null;
}

function onConfirmApply() {
  if (pendingConfirmCallback) {
    var callback = pendingConfirmCallback;
    hideConfirmDialog();
    callback();
  }
}

function onConfirmCancel() {
  hideConfirmDialog();
}

// ========== Result Message ==========

function showResultMessage(message, isSuccess) {
  var resultEl = document.getElementById("result-message");
  var textEl = document.getElementById("result-text");
  var iconEl = document.getElementById("result-icon");
  
  if (!resultEl || !textEl || !iconEl) return;
  
  textEl.textContent = message;
  
  // Reset icon classes
  iconEl.className = "ms-Icon";
  
  if (isSuccess) {
    iconEl.classList.add("ms-Icon--CheckMark", "success");
  } else {
    iconEl.classList.add("ms-Icon--ErrorBadge", "error");
  }
  
  resultEl.style.display = "flex";
}

function hideResultMessage() {
  var resultEl = document.getElementById("result-message");
  if (resultEl) {
    resultEl.style.display = "none";
  }
}

// ========== Plan Item Rendering ==========

function setPlanItemSelected(planItemEl, selected) {
  var checkbox = planItemEl.querySelector('input[type="checkbox"]');
  if (checkbox) {
    checkbox.checked = selected;
  }
  
  if (selected) {
    planItemEl.classList.add("selected");
  } else {
    planItemEl.classList.remove("selected");
  }
  
  updateApplyButtonState();
}

function renderDocPlan(planItems) {
  var listEl = document.getElementById("doc-plan-list");
  if (!listEl) return;
  
  listEl.innerHTML = "";
  
  if (!Array.isArray(planItems) || planItems.length === 0) {
    var emptyEl = document.createElement("div");
    emptyEl.className = "plan-list-empty";
    emptyEl.textContent = "No suggested changes found.";
    listEl.appendChild(emptyEl);
    
    // Hide controls and apply section if no items
    showSection("plan-results-section", true);
    var controlsEl = document.querySelector(".plan-controls");
    if (controlsEl) controlsEl.style.display = "none";
    showSection("apply-section", false);
    updatePlanCount();
    return;
  }
  
  planItems.forEach(function(item) {
    var planItemEl = document.createElement("div");
    planItemEl.className = "plan-item selected";
    planItemEl.dataset.title = item.title || "";
    planItemEl.dataset.description = item.description || "";
    
    // Header with checkbox
    var headerEl = document.createElement("div");
    headerEl.className = "plan-item-header";
    
    var labelEl = document.createElement("label");
    labelEl.className = "plan-checkbox";
    
    var checkboxEl = document.createElement("input");
    checkboxEl.type = "checkbox";
    checkboxEl.checked = true;
    
    var titleEl = document.createElement("span");
    titleEl.className = "plan-item-title ms-font-m";
    titleEl.textContent = item.title || "Untitled";
    
    labelEl.appendChild(checkboxEl);
    labelEl.appendChild(titleEl);
    headerEl.appendChild(labelEl);
    
    // Description
    var descEl = document.createElement("p");
    descEl.className = "plan-item-description ms-font-s";
    descEl.textContent = item.description || "";
    
    planItemEl.appendChild(headerEl);
    if (item.description) {
      planItemEl.appendChild(descEl);
    }
    
    // Checkbox change handler
    checkboxEl.addEventListener("change", function() {
      setPlanItemSelected(planItemEl, checkboxEl.checked);
    });
    
    // Click on item toggles checkbox
    planItemEl.addEventListener("click", function(e) {
      if (e.target !== checkboxEl) {
        checkboxEl.checked = !checkboxEl.checked;
        setPlanItemSelected(planItemEl, checkboxEl.checked);
      }
    });
    
    listEl.appendChild(planItemEl);
  });
  
  // Show sections
  showSection("plan-results-section", true);
  var controlsEl = document.querySelector(".plan-controls");
  if (controlsEl) controlsEl.style.display = "block";
  showSection("apply-section", true);
  
  updatePlanCount();
  updateApplyButtonState();
}

// ========== Select All / Clear All ==========

function selectAllPlanItems() {
  var listEl = document.getElementById("doc-plan-list");
  if (!listEl) return;
  
  var items = listEl.querySelectorAll(".plan-item");
  items.forEach(function(itemEl) {
    setPlanItemSelected(itemEl, true);
  });
}

function clearAllPlanItems() {
  var listEl = document.getElementById("doc-plan-list");
  if (!listEl) return;
  
  var items = listEl.querySelectorAll(".plan-item");
  items.forEach(function(itemEl) {
    setPlanItemSelected(itemEl, false);
  });
}

// ========== Build Plan Selections ==========

function buildPlanSelections() {
  var listEl = document.getElementById("doc-plan-list");
  if (!listEl) {
    return { selectedItems: [], unselectedItems: [] };
  }
  
  var planItems = Array.from(listEl.querySelectorAll(".plan-item"));
  
  var selectedItems = planItems
    .filter(function(itemEl) {
      var checkbox = itemEl.querySelector('input[type="checkbox"]');
      return checkbox && checkbox.checked;
    })
    .map(function(itemEl) {
      return {
        title: itemEl.dataset.title || "",
        description: itemEl.dataset.description || ""
      };
    })
    .filter(function(item) {
      return item.title || item.description;
    });
  
  var unselectedItems = planItems
    .filter(function(itemEl) {
      var checkbox = itemEl.querySelector('input[type="checkbox"]');
      return checkbox && !checkbox.checked;
    })
    .map(function(itemEl) {
      return {
        title: itemEl.dataset.title || "",
        description: itemEl.dataset.description || ""
      };
    })
    .filter(function(item) {
      return item.title || item.description;
    });
  
  return { selectedItems: selectedItems, unselectedItems: unselectedItems };
}

// ========== API Functions ==========

async function fetchEdits({
  ccId,
  hash,
  paragraph_text,
  doc_text,
  context,
  selected_plan_items,
  unselected_plan_items,
}) {
  var resp = await fetch(EDIT_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-API-Key": API_KEY },
    body: JSON.stringify({
      ccId: ccId,
      hash: hash,
      paragraph_text: paragraph_text,
      doc_text: doc_text,
      context: context,
      selected_plan_items: selected_plan_items,
      unselected_plan_items: unselected_plan_items,
    }),
  });

  if (!resp.ok) {
    var body = await resp.text().catch(function() { return ""; });
    throw new Error("API " + resp.status + ": " + (body || resp.statusText));
  }

  var data = await resp.json();
  return data.edits;
}

async function fetchDocPlan({ doc_text, context, timeoutMs, pollIntervalMs }) {
  timeoutMs = timeoutMs || 120000;
  pollIntervalMs = pollIntervalMs || 2000;
  
  var controller = new AbortController();
  var timeoutId = setTimeout(function() { controller.abort(); }, timeoutMs);
  var resp;
  
  try {
    resp = await fetch(PLAN_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-API-Key": API_KEY },
      body: JSON.stringify({ doc_text: doc_text, context: context }),
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeoutId);
  }

  if (!resp.ok) {
    var body = await resp.text().catch(function() { return ""; });
    throw new Error("API " + resp.status + ": " + (body || resp.statusText));
  }

  var data = await resp.json();
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.plan)) return data.plan;
  if (Array.isArray(data.issues)) return data.issues;

  if (data && data.status && data.job_id) {
    if (data.status === "done" && Array.isArray(data.plan)) {
      return data.plan;
    }
    if (data.status === "error") {
      throw new Error(data.error || "Analysis failed");
    }

    var startTime = Date.now();
    while (Date.now() - startTime < timeoutMs) {
      await new Promise(function(resolve) { setTimeout(resolve, pollIntervalMs); });
      var statusResp = await fetch(PLAN_STATUS_URL + "/" + data.job_id, {
        headers: { "X-API-Key": API_KEY },
      });
      if (!statusResp.ok) {
        var statusBody = await statusResp.text().catch(function() { return ""; });
        throw new Error("Status check failed: " + (statusBody || statusResp.statusText));
      }
      var statusData = await statusResp.json();
      if (statusData.status === "done" && Array.isArray(statusData.plan)) {
        return statusData.plan;
      }
      if (statusData.status === "error") {
        throw new Error(statusData.error || "Analysis failed");
      }
    }
    throw new Error("Analysis timed out. Please try again.");
  }

  console.warn("Unexpected doc plan response shape:", data);
  return [];
}

// ========== Word Document Helpers ==========

async function getRangeBySearch(context, paragraphRange, offset, fullText) {
  if (offset === 0) {
    return paragraphRange.getRange(Word.RangeLocation.start);
  }
  if (offset >= fullText.length) {
    return paragraphRange.getRange(Word.RangeLocation.end);
  }

  var char = fullText[offset];
  var occurrenceIndex = 0;
  for (var i = 0; i < offset; i++) {
    if (fullText[i] === char) {
      occurrenceIndex++;
    }
  }

  var searchResults = paragraphRange.search(char, { matchCase: true, matchWholeWord: false });
  searchResults.load("items");
  await context.sync();

  if (occurrenceIndex >= searchResults.items.length) {
    console.warn("Could not find occurrence " + occurrenceIndex + " of char '" + char + "' at offset " + offset);
    throw new Error("Mapping mismatch at offset " + offset);
  }

  return searchResults.items[occurrenceIndex];
}

async function applyEditsToRange(context, range, originalText, edits) {
  var sorted = edits.slice().sort(function(a, b) {
    return (b.start || 0) - (a.start || 0);
  });

  for (var idx = 0; idx < sorted.length; idx++) {
    var e = sorted[idx];
    var start = e.start || 0;
    var end = e.end || start;
    
    if (start < 0 || start > originalText.length) {
      console.warn("Edit at offset " + start + " out of range, skipping");
      continue;
    }

    if (e.type === "insert") {
      try {
        var targetRange = await getRangeBySearch(context, range, start, originalText);
        targetRange.insertText(e.text || "", Word.InsertLocation.before);
        await context.sync();
        console.log("Inserted \"" + e.text + "\" at " + start);
      } catch (err) {
        console.error("Insert failed at " + start + ":", err);
      }
      
    } else if (e.type === "delete" || e.type === "replace") {
      try {
        var lenToRemove = end - start;
        if (lenToRemove <= 0) continue;

        var startCharRange = await getRangeBySearch(context, range, start, originalText);
        var endCharIndex = end - 1;
        var endCharRange = await getRangeBySearch(context, range, endCharIndex, originalText);
        var deleteRange = startCharRange.expandTo(endCharRange);

        if (e.type === "delete") {
          deleteRange.delete();
          console.log("Deleted range [" + start + ", " + end + "]");
        } else {
          deleteRange.insertText(e.text || "", Word.InsertLocation.replace);
          console.log("Replaced range [" + start + ", " + end + "] with \"" + e.text + "\"");
        }
        await context.sync();
      } catch (err) {
        console.error("Edit failed at [" + start + ", " + end + "]:", err);
      }
    }
  }
}

// ========== Main Functions ==========

export async function runDocEditPlan() {
  var contextInput = document.getElementById("ai-context");
  var userContext = contextInput && typeof contextInput.value === "string" ? contextInput.value : "";

  setButtonLoading("run-doc-plan", true);
  setStatus("analyze-status", "Analyzing document...", "");
  
  // Reset/hide previous results
  showSection("plan-results-section", false);
  showSection("apply-section", false);

  try {
    var docText = await Word.run(async function(contextObj) {
      var docBody = contextObj.document.body;
      docBody.load("text");
      await contextObj.sync();
      return docBody.text || "";
    });

    var planItems = await fetchDocPlan({ 
      doc_text: docText, 
      context: userContext, 
      timeoutMs: 120000 
    });
    
    renderDocPlan(planItems);
    
    var itemCount = planItems.length;
    if (itemCount > 0) {
      setStatus("analyze-status", "Found " + itemCount + " suggested change" + (itemCount === 1 ? "" : "s") + ".", "success");
    } else {
      setStatus("analyze-status", "No changes suggested for this document.", "");
    }
  } catch (e) {
    console.error("Failed to analyze document:", e);
    var errorMsg = "Analysis failed. ";
    if (e.message && e.message.indexOf("timed out") !== -1) {
      errorMsg += "The request timed out. Please try again.";
    } else if (e.message && e.message.indexOf("API") !== -1) {
      errorMsg += "Could not connect to the server.";
    } else {
      errorMsg += "Please try again.";
    }
    setStatus("analyze-status", errorMsg, "error");
  } finally {
    setButtonLoading("run-doc-plan", false);
  }
}

export async function runAiEditsOverWholeDoc() {
  var contextInput = document.getElementById("ai-context");
  var userContext = contextInput && typeof contextInput.value === "string" ? contextInput.value : "";
  var selections = buildPlanSelections();
  var selectedItems = selections.selectedItems;
  var unselectedItems = selections.unselectedItems;

  setButtonLoading("run-ai-edits", true);
  setStatus("apply-status", "Preparing to apply changes...", "");
  
  var totalEditsApplied = 0;
  var paragraphsProcessed = 0;

  try {
    // Step 1: Wrap paragraphs and extract info
    var items = await Word.run(async function(context) {
      var paragraphs = context.document.body.paragraphs;
      paragraphs.load("items");
      
      var docBody = context.document.body;
      docBody.load("text");
      
      await context.sync();

      var docText = docBody.text || "";

      var out = [];
      for (var i = 0; i < paragraphs.items.length; i++) {
        var p = paragraphs.items[i];
        var pRange = p.getRange();
        pRange.load("text");
        out.push({ pRange: pRange, order: i });
      }
      await context.sync();

      var itemsWithCC = [];
      for (var j = 0; j < out.length; j++) {
        var pRange = out[j].pRange;
        var order = out[j].order;
        var text = pRange.text || "";
        
        if (!text.trim()) {
          console.log("Skipping empty paragraph " + (order + 1));
          continue;
        }
        
        var cc = pRange.insertContentControl();
        cc.tag = CC_TAG;
        cc.title = "AI Paragraph " + (order + 1);
        cc.load("id");
        
        var ccRange = cc.getRange();
        ccRange.load("text");
        itemsWithCC.push({ cc: cc, ccRange: ccRange, order: order });
      }
      await context.sync();

      return itemsWithCC.map(function(item) {
        return {
          ccId: item.cc.id,
          order: item.order,
          paragraph_text: item.ccRange.text || "",
          hash: fastHash(item.ccRange.text || ""),
          doc_text: docText,
        };
      });
    });

    var totalParagraphs = items.length;

    // Step 2: Process edits
    for (var idx = 0; idx < items.length; idx++) {
      var item = items[idx];
      var ccId = item.ccId;
      var paragraph_text = item.paragraph_text;
      var hash = item.hash;
      var doc_text = item.doc_text;
      var order = item.order;
      
      if (!paragraph_text.trim()) continue;

      paragraphsProcessed++;
      setStatus("apply-status", "Processing paragraph " + paragraphsProcessed + " of " + totalParagraphs + "...", "");

      var edits;
      try {
        edits = await fetchEdits({
          ccId: ccId,
          hash: hash,
          paragraph_text: paragraph_text,
          doc_text: doc_text,
          context: userContext,
          selected_plan_items: selectedItems,
          unselected_plan_items: unselectedItems,
        });
      } catch (e) {
        console.error("API failed for Para " + (order + 1) + ":", e);
        continue;
      }

      if (!edits || edits.length === 0) continue;

      totalEditsApplied += edits.length;

      await Word.run(async function(context) {
        context.document.changeTrackingMode = Word.ChangeTrackingMode.trackAll;
        var cc = context.document.contentControls.getById(ccId);
        var range = cc.getRange();
        await applyEditsToRange(context, range, paragraph_text, edits);
      });
    }

    // Success
    setStatus("apply-status", "", "");
    var successMsg = "Done! ";
    if (totalEditsApplied > 0) {
      successMsg += totalEditsApplied + " change" + (totalEditsApplied === 1 ? "" : "s") + " applied with Track Changes enabled.";
    } else {
      successMsg += "No changes were needed.";
    }
    showResultMessage(successMsg, true);
    
  } catch (e) {
    console.error("Failed to apply edits:", e);
    setStatus("apply-status", "", "");
    showResultMessage("Failed to apply changes. Please try again.", false);
  } finally {
    setButtonLoading("run-ai-edits", false);
    updateApplyButtonState();
  }
}

function handleApplyClick() {
  var selectedCount = getSelectedCount();
  if (selectedCount === 0) {
    showResultMessage("Please select at least one change to apply.", false);
    return;
  }
  
  var message = "Apply " + selectedCount + " change" + (selectedCount === 1 ? "" : "s") + " to your document? All changes will be tracked.";
  showConfirmDialog(message, function() {
    runAiEditsOverWholeDoc().catch(function(err) {
      console.error(err);
      showResultMessage("An unexpected error occurred.", false);
    });
  });
}

// ========== Initialization ==========

Office.onReady(function() {
  // Analyze Document button
  var planBtn = document.getElementById("run-doc-plan");
  if (planBtn) {
    planBtn.onclick = function() {
      runDocEditPlan().catch(function(err) {
        console.error(err);
        setStatus("analyze-status", "An unexpected error occurred.", "error");
        setButtonLoading("run-doc-plan", false);
      });
    };
  }

  // Apply Changes button (with confirmation)
  var applyBtn = document.getElementById("run-ai-edits");
  if (applyBtn) {
    applyBtn.onclick = handleApplyClick;
  }

  // Select All button
  var selectAllBtn = document.getElementById("select-all-btn");
  if (selectAllBtn) {
    selectAllBtn.onclick = selectAllPlanItems;
  }

  // Clear All button
  var clearAllBtn = document.getElementById("clear-all-btn");
  if (clearAllBtn) {
    clearAllBtn.onclick = clearAllPlanItems;
  }

  // Confirmation dialog buttons
  var confirmApplyBtn = document.getElementById("confirm-apply");
  if (confirmApplyBtn) {
    confirmApplyBtn.onclick = onConfirmApply;
  }

  var confirmCancelBtn = document.getElementById("confirm-cancel");
  if (confirmCancelBtn) {
    confirmCancelBtn.onclick = onConfirmCancel;
  }

  // Result message dismiss button
  var resultDismissBtn = document.getElementById("result-dismiss");
  if (resultDismissBtn) {
    resultDismissBtn.onclick = hideResultMessage;
  }
});
